/**
 * Head Init - Script di inizializzazione da caricare prima di tutti gli altri
 *
 * Contiene utility fondamentali che devono essere disponibili immediatamente:
 * - domLoaded: helper per eseguire callback quando il DOM è pronto
 * - Tracciamento prima visita del sito
 */

/**
 * Esegue una callback quando il DOM è pronto.
 * Se il DOM è già caricato, esegue immediatamente.
 *
 * @param {Function} callback - Funzione da eseguire
 */
window.domLoaded = function (callback) {
    if (document.readyState !== 'loading') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
};

/**
 * Salva il timestamp della prima visita al sito nel localStorage
 */
(function () {
    try {
        var k = 'site.firstSeenAt';
        if (!window.localStorage.getItem(k)) {
            window.localStorage.setItem(k, String(Date.now()));
        }
    } catch (e) { }
})();
